import {Operation} from "./Operation.js";
import jStat from "jstat";
import {PERCENT} from "../../../../constants";


export class Percentile extends Operation {

    static displayName() {
        return "Percentile";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return false; // Percentile is not typically used for date values
    }

    static typeOverride() {
        return PERCENT;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = {
                values: [],
                sum: 0,
                count: 0
            };
        }
        if (newValue !== null && newValue !== undefined) {
            this.currValue.values.push(newValue);
            this.currValue.sum += newValue;
            this.currValue.count += 1;
        } else {
            this.currValue.values.push(0);
            this.currValue.count += 1;
        }
    }

    finish(globalAggregation) {
        if (this.currValue === null || this.currValue.count === 0) {
            return 0; // No values to calculate percentile
        }
        return jStat.percentileOfScore(globalAggregation.currValue.values, this.currValue.sum / this.currValue.count);
    }
}


export default Percentile;